import merge from 'deepmerge';
import { combineReducers } from 'redux';

const blankets = () => (
  state = {
    // inital states here
    blanketsData: null,
  },
  action,
) => {
  if (action.type === 'BLANKETS_SUCCESS' && action.response.entities) {
    return merge.all([state, action.response.entities], {
      clone: false,
      arrayMerge: (destinationArray, sourceArray) => sourceArray,
    });
  }
  return state;
};

export default combineReducers({
  blankets: blankets(),
});
